import { useSignal } from "@preact/signals-react";
import { FocusEventHandler, KeyboardEventHandler, Ref } from "react";

export type TextProps = {
  id: string;
  inputRef: Ref<HTMLElement>;
  textAreaValue: Array<any>;
  checkNodeArr: Array<any>;
  placeholder: string;
  isLongPress: boolean;
  isResized: boolean;
  onTextAreaBlur: (e: any, value?: any) => void;
  onTextAreaFocus: FocusEventHandler<HTMLTextAreaElement>;
  onTextAreaEnter: KeyboardEventHandler<HTMLTextAreaElement>;
  setTextAreaValueWithParam: Function;
  guideNodeEditable: boolean;
  isTargetNode: boolean;
  showStopGenerateBtn: boolean;
  parentNodeId: string;
  noWheelClassName: string;
  enableFeedback?: boolean;
  isStaticApp: boolean;
  isInBlueprint?: boolean;
  resizeEventParams: { width: number; height: number };
  displayType: string;
  type: string;
};

export class TextNodeBloc {
  placeHolder = useSignal("Enter input");

  textValue = useSignal("");

  isInBlueprint = useSignal(false);

  constructor(public props: TextProps) {
    this.textValue.value = props.textAreaValue[0].results[0].content || "";
    this.isInBlueprint.value = props.isInBlueprint ?? false;
    if (props.placeholder) {
      this.placeHolder.value = props.placeholder;
    } else {
      if (props.parentNodeId) {
        this.placeHolder.value = "Output shown here";
      } else {
        this.placeHolder.value = "Enter input";
      }
    }
  }

  reSizeStyle() {
    let reSizeStyle: { width?: number | string; height?: number | string } = { width: undefined, height: undefined };
    reSizeStyle.width = "100%";
    if (this.props.resizeEventParams && this.props.resizeEventParams.width) {
      reSizeStyle.width = this.props.resizeEventParams.width - 20;
    }
    if (this.props.resizeEventParams && this.props.resizeEventParams.height) {
      reSizeStyle.height = this.props.resizeEventParams.height - 42 - (this.props.enableFeedback ? 40 : 0);
    } else {
      reSizeStyle.height = undefined;
    }
    return reSizeStyle;
  }
}
